import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdLockOutline } from "react-icons/md";
import ShipperNavBar from "../../Components/Navbar/ShipperNavBar";
import WarehouseNavBar from "../../Components/Navbar/WarehouseNavBar";
import CarrierNavbar from "../../Components/Navbar/CarrierNavbar";
import { useTranslation } from "react-i18next";

const Unauthorized = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/Login");
  };

  const renderNavbar = () => {
    if (
      user?.role === "Shipper" ||
      user?.role === "ShipperUser" ||
      user?.role === "oneTimeShipper"
    ) {
      return <ShipperNavBar />;
    }
    if (user?.role === "warehouseUser") {
      return <WarehouseNavBar />;
    }
    if (user?.role === "Carrier") {
      return <CarrierNavbar />;
    }
    return null;
  };

  const profilePath =
    user?.role === "warehouseUser" ? "/warehouse-user-profile" : "/Profile";

  return (
    <>
      {renderNavbar()}
      <div className="flex flex-col items-center justify-center px-4 py-16 min-h-[calc(100vh-100px)] bg-ui-surface-sunken">
        <div className="bg-ui-surface rounded-lg shadow-md p-10 max-w-md w-full text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-state-danger-bg rounded-full p-4">
              <MdLockOutline size={40} className="text-state-danger" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-ui-text mb-3">
            {t("unauthorized.title")}
          </h1>
          <p className="text-ui-text-muted mb-6 text-sm">
            {t("unauthorized.body")}
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => navigate(profilePath)}
              className="flex-1 bg-brand hover:bg-brand-hover text-white font-medium py-2 px-4 rounded transition-colors"
            >
              {t("unauthorized.goToProfile")}
            </button>
            <button
              onClick={handleLogout}
              className="flex-1 bg-ui-surface hover:bg-ui-surface-sunken text-ui-text font-medium py-2 px-4 rounded border border-ui-border transition-colors"
            >
              {t("actions.logout")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Unauthorized;
